/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import "./src/index.css"

export const onServiceWorkerUpdateReady = () => {
	// Show a top banner (matching NewArticleBanner style) so the user can refresh when ready.
	const banner = document.createElement("div");
	banner.setAttribute("role", "alert");
	banner.className = "w-full bg-primary text-primary-foreground";
	banner.style.cssText = "position:fixed;top:0;left:0;right:0;z-index:99999;";
	banner.innerHTML = `
		<div class="container flex items-center gap-3 py-2 px-4 text-sm">
			<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 shrink-0" viewBox="0 0 24 24" fill="none"
				stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
				<path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
				<path d="M3 3v5h5"/>
				<path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/>
				<path d="M16 21h5v-5"/>
			</svg>
			<p class="flex-1 min-w-0 truncate">
				<span class="font-semibold mr-1.5">Stockmantics updated:</span>
				<button id="sw-update-btn"
					class="underline underline-offset-2 hover:opacity-80 transition-opacity bg-transparent border-none text-inherit cursor-pointer p-0 text-sm">
					Refresh to see the latest content and features
				</button>
			</p>
			<button id="sw-dismiss-btn"
				class="shrink-0 rounded-md p-1 transition-colors hover:bg-primary-foreground/20 bg-transparent border-none text-inherit cursor-pointer"
				aria-label="Dismiss">
				<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none"
					stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
					<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
				</svg>
			</button>
		</div>
	`;

	document.body.prepend(banner);

	banner.querySelector("#sw-update-btn").addEventListener("click", () => {
		sessionStorage.setItem("swUpdated", "true");
		window.location.reload();
	});
	banner.querySelector("#sw-dismiss-btn").addEventListener("click", () => {
		banner.remove();
	});
};

export const onServiceWorkerActive = () => {
	// Poll for SW updates every 5 minutes so idle tabs pick up new deployments.
	if ("serviceWorker" in navigator) {
		setInterval(() => {
			navigator.serviceWorker.getRegistration().then(reg => {
				if (reg) reg.update();
			});
		}, 5 * 60 * 1000);
	}
};